import React from 'react';
import { ripImg, jamImg, coinImg } from '../assets/images';
import './HUD.css';

const HUD = ({ score, missed, timeLeft }) => {
  return (
    <div className="hud">
      <div className="badge">
        <img src={ripImg} alt="RIP" className="rip-icon" />
        <span>{missed}</span>
      </div>
      <div className="badge">
        <img src={jamImg} alt="Timer" className="jam-icon" />
        <span>{timeLeft}</span>
      </div>
      <div className="badge">
        <img src={coinImg} alt="Score" className="coin-icon" />
        <span>{score}</span>
      </div>
    </div>
  );
};

export default HUD;

